var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 28C10.1091 28 5.3335 23.2244 5.3335 17.3333C5.3335 11.4423 10.1091 6.66666 16.0002 6.66666C21.8912 6.66666 26.6668 11.4423 26.6668 17.3333C26.6668 23.2244 21.8912 28 16.0002 28Z",
    fill: "#E5D062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 6.7492V5.33334H18.6667C19.403 5.33334 20 4.73638 20 4.00001C20 3.26363 19.403 2.66667 18.6667 2.66667H13.3333C12.597 2.66667 12 3.26363 12 4.00001C12 4.73638 12.597 5.33334 13.3333 5.33334H14.6667V6.7492C15.1035 6.69473 15.5485 6.66667 16 6.66667C16.4515 6.66667 16.8965 6.69473 17.3333 6.7492Z",
    fill: "#E5D062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2227 10.5386L25.5019 9.25939C25.8925 8.86887 25.8925 8.2357 25.5019 7.84518L25.0305 7.37377C24.64 6.98325 24.0068 6.98325 23.6163 7.37377L22.2798 8.7103C23.0013 9.23667 23.6543 9.8514 24.2227 10.5386Z",
    fill: "#E5D062"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2976 10.4617C15.3177 10.2012 15.5349 10 15.7962 10H16.2035C16.4647 10 16.6819 10.2012 16.702 10.4617L17.2917 18.1283C17.3141 18.4187 17.0845 18.6667 16.7932 18.6667H15.2064C14.9152 18.6667 14.6855 18.4187 14.7079 18.1283L15.2976 10.4617Z",
    fill: "#E5D062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.61ff593f42b27f7e888188ab1bb9f719.svg";
export { ForwardRef as ReactComponent };